import checkCircle from "./checkCircle.svg";

export { checkCircle };
